import { Stack } from 'expo-router';

export default function ArticleInstanceLayout() {
    return <Stack screenOptions={{ headerShown: false }} />;
}
